export default "<app-task-list></app-task-list>\r\n";